 <span class="count-badge bg-danger">
            {{ count() }}</span>
